import { render, staticRenderFns } from "./ChartCPI.vue?vue&type=template&id=b37bc66e&scoped=true&"
import script from "./ChartCPI.vue?vue&type=script&lang=js&"
export * from "./ChartCPI.vue?vue&type=script&lang=js&"
import style0 from "./ChartCPI.vue?vue&type=style&index=0&id=b37bc66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37bc66e",
  null
  
)

export default component.exports